/**
 * @Author: willian.wang
 * @Date: 2022-08-23
 * @LastEditTime: 2022-08-23 11:34:00
 * @LastEditors: willian.wang
 * @Description: 左减右加特定样式数字输入框
 */

import { InputNumber } from 'antd';
import type { InputNumberProps } from 'antd';
import styles from './index.less';
import classnames from 'classnames';

interface InputNumberType1Props extends InputNumberProps {
  onIncrease: () => void;
  onDecrease: () => void;
}

const InputNumberType1 = (props: InputNumberType1Props) => {
  const { onIncrease, onDecrease, ...rest } = props;
  const increaseBtn = (
    <div
      className={classnames(styles['input-btn'], styles.btn1)}
      onClick={onIncrease}
    >
      {/* <img
        src='https://static.huolala.cn/image/238b138071e2aee66d7926425e1433e34bdde4e8.png'
      /> */}
    </div>
  );
  const decreaseBtn = (
    <div
      className={classnames(styles['input-btn'], styles.btn2)}
      onClick={onDecrease}
    >
      {/* <img
        src='https://static.huolala.cn/image/c59f96e2dae40d35ebef8f4357f1ca1442744134.png'
      /> */}
    </div>
  );
  return (
    <InputNumber
      className={styles['inputnumber-type1']}
      {...rest}
      addonBefore={decreaseBtn}
      addonAfter={increaseBtn}
      controls={false}
    />
  );
};

export default InputNumberType1;
